import { setTokens } from '../slices/tokenSlice';

export const TOKEN_NAME = 'CHECKOUT-TRANS-TOKEN';

export const TRANS_TOKEN_SESSION_ITEM_NAME_SUFFIX = '_CHECKOUTTRANSTOKEN';

export const prepareHeaders = ({ headers, collectHeaderToken, widgetNameSpace }) => {
  if (!collectHeaderToken) {
    return headers;
  }
  const header = headers;
  const transTokenSessionItemName = `${widgetNameSpace}${TRANS_TOKEN_SESSION_ITEM_NAME_SUFFIX}`;
  const headerToken = sessionStorage.getItem(transTokenSessionItemName);
  if (headerToken) {
    header[`${TOKEN_NAME}`] = headerToken;
  }
  return header;
};

export const storeTokens = ({
  response, payload, api, widgetNameSpace,
}) => {
  const transTokenSessionItemName = `${widgetNameSpace}${TRANS_TOKEN_SESSION_ITEM_NAME_SUFFIX}`;
  const headerToken = response.headers.get(TOKEN_NAME);
  if (headerToken) {
    api.dispatch(setTokens({ headerToken }));
    sessionStorage.setItem(transTokenSessionItemName, headerToken);
  }

  const urlAccessToken = payload.token;
  urlAccessToken && api.dispatch(setTokens({ accessToken: urlAccessToken }));
};

export const removeTransToken = (transTokenSessionItemName) => {
  sessionStorage.removeItem(transTokenSessionItemName);
};
